// extracted by mini-css-extract-plugin
export default {"root":"Navigation_root__mcd9d","rootCard":"Navigation_rootCard__lAMV4","navItem":"Navigation_navItem__eVBCq","navItemSelected":"Navigation_navItemSelected__yFN2q"};